import Modal from "./modal.js";

export default class StakeholderMultiEditModal extends Modal {
  constructor(stakeholders, countries) {
    super("stakeholder-multiedit-modal");
    this.countries = countries;
    this.companyId = window.currentCompany.id;
    this.$loader = this.$modal._element.querySelector('[name="loader"]');

    this.buildGroupsList(stakeholders);
    this.setupSpreadsheet();
    this.setupListeners();
    this.timeoutId = null;

    const workerCode = `
      self.onmessage = (event) => {
        const data = event.data;
        const seen = new Map();
        const keyIndices = [1, 2, 5, 7, 8];
        const colors = [
          "#FFB3BA", "#BAFFC9", "#BAE1FF", "#FFFFBA", "#FFDFBA", "#E0BBE4",
          "#D4A5A5", "#A5D4A5", "#A5A5D4", "#D4D4A5", "#D4A5C9", "#A5C9D4",
          "#FFA07A", "#98FB98", "#87CEFA", "#F0E68C", "#DDA0DD", "#20B2AA",
          "#FF6961", "#77DD77", "#AEC6CF", "#F49AC2", "#FDFD96", "#84B6F4",
          "#FDCB6E", "#FF9FF3", "#C5E1A5", "#B39DDB", "#FFAB91", "#80DEEA",
          "#F8BBD0", "#BCAAA4", "#B0BEC5", "#FFF59D", "#FFCC80", "#81D4FA",
          "#A5D6A7", "#CE93D8", "#EF9A9A", "#90CAF9", "#9FA8DA", "#FFAB00",
          "#00C853", "#00B8D4", "#6200EA", "#FFAB40", "#FF6E40", "#00BFA5"
        ];

        let colorIndex = 0;
        // Realizar la detección de duplicados
        data.forEach((row, index) => {
          if (!row[1]) return;
          const key = keyIndices.map(i => row[i]).join('|');
          if (seen.has(key)) {
            const { color, indices } = seen.get(key);
            indices.push(index);
          } else {
            const color = colors[colorIndex % colors.length];
            seen.set(key, { color, indices: [index] });
            colorIndex++;
          }
        });

        console.dir(seen);
        // Enviar el resultado de vuelta al hilo principal
        self.postMessage(seen);
      };
    `;

    this.workerUrl = URL.createObjectURL(new Blob([workerCode], { type: 'application/javascript' }));
  }

  findDuplicates(instance) {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      const worker = new Worker(this.workerUrl);
      worker.postMessage(instance.jexcel.getData());

      worker.onmessage = (event) => {
        const duplicates = event.data;
        const colors = [
          "#FFB3BA", "#BAFFC9", "#BAE1FF", "#FFFFBA", "#FFDFBA", "#E0BBE4",
          "#D4A5A5", "#A5D4A5", "#A5A5D4", "#D4D4A5", "#D4A5C9", "#A5C9D4",
          "#FFA07A", "#98FB98", "#87CEFA", "#F0E68C", "#DDA0DD", "#20B2AA",
          "#FF6961", "#77DD77", "#AEC6CF", "#F49AC2", "#FDFD96", "#84B6F4",
          "#FDCB6E", "#FF9FF3", "#C5E1A5", "#B39DDB", "#FFAB91", "#80DEEA",
          "#F8BBD0", "#BCAAA4", "#B0BEC5", "#FFF59D", "#FFCC80", "#81D4FA",
          "#A5D6A7", "#CE93D8", "#EF9A9A", "#90CAF9", "#9FA8DA", "#FFAB00",
          "#00C853", "#00B8D4", "#6200EA", "#FFAB40", "#FF6E40", "#00BFA5"
        ];

        // Establecer el color de las celdas que contienen duplicados
        duplicates.forEach((duplicate, index) => {
          const indices = duplicate.indices;

          const color = duplicate.indices.length === 1 ? 'white' : duplicate.color;
          indices.forEach((i) => {
            for(let col = 0; col < 16; col++) {
              const cell = instance.jexcel.el.querySelector(`[data-x="${col}"][data-y="${i}"]`);
              if (cell) cell.style.backgroundColor = color;
            }
          });
        });
      };
    }, 500); // retrasa la ejecución durante 500ms
  }
  
  setupListeners() {
    document.getElementById("add-stakeholder").addEventListener("click", () => {
      this.spreadsheet.insertRow();
    });

    this.$modal._element
      .querySelector("[data-action-download]")
      .addEventListener("click", () => {
        this.download();
      });
  }

  buildGroupsList(stakeholders) {
    this.groups = [
      trans("board_members"),
      trans("founders"),
      trans("employees"),
      trans("investors"),
      trans("external_advisors"),
      trans("alumni"),
    ];

    stakeholders.forEach((stakeholder) => {
      if (stakeholder.group && !this.groups.includes(stakeholder.group)) {
        this.groups.push(stakeholder.group);
      }
    });
  }

  reset() {
    this.listenToChanges = false;
    this.changedRows = [];
    this.spreadsheet.setData([[]]);
  }

  add(stakeholder) {
    const data = [
      stakeholder.id,
      stakeholder.name,
      stakeholder.surnames,
      stakeholder.type,
      stakeholder.group,
      stakeholder.email,
      false,
      stakeholder.phone,
      stakeholder.identifier,
      stakeholder.custom_identifier,
      stakeholder.birth_date,
      stakeholder.civil_status,
      stakeholder.nationality,
      stakeholder.street,
      stakeholder.postal_code,
      stakeholder.city,
      stakeholder.country,
    ];

    if (
      this.countRows() === 1 &&
      this.spreadsheet.el.querySelector('[data-x="0"][data-y="0"]').innerText
        .length === 0
    ) {
      this.spreadsheet.setRowData(0, data);
    } else {
      this.spreadsheet.insertRow(data);
    }
  }

  onFinishedInserting() {
    this.addExtras();
    this.listenToChanges = true;
  }

  addExtras() {
    if (this.spreadsheet.getData().length < 10) {
      this.spreadsheet.insertRow([]);
      this.spreadsheet.insertRow([]);
      this.spreadsheet.insertRow([]);
      this.spreadsheet.insertRow([]);
    }
  }

  countRows() {
    return this.spreadsheet.options.data.length;
  }

  getData() {
    let list = [];

    this.spreadsheet.getData().forEach((data, i) => {
      if (!this.changedRows.includes(i)) {
        return;
      }

      // since the final list wont match the real i position, we have to track it here
      // so we can later display errors on the proper row
      let stakeholder = {
        rowI: i,
      };
      data.forEach((v, k) => {
        const column = this.spreadsheet.options.columns[k];
        stakeholder[column.name] = v;
      });

      // only push filled rows
      if (stakeholder.name.length > 0) {
        list.push(stakeholder);
      }
    });

    return list;
  }

  hideColumns(columnNumbers = []) {
    columnNumbers.forEach((n) => this.spreadsheet.hideColumn(n));
  }

  setupSpreadsheet() {
    return new Promise((resolve, reject) => {
      this.spreadsheet = jspreadsheet(
        document.getElementById("stakeholders-spreadsheet"),
        {
          about: false,
          tableOverflow: true,
          tableHeight: "auto",
          tableWidth: "100vw",
          data: [{}, {}],
          columns: [
            { type: "text", name: "id", title: "id", width: 1 },
            { type: "text", name: "name", title: trans("name"), width: 120 },
            {
              type: "text",
              name: "surnames",
              title: trans("last_name"),
              width: 100,
            },
            {
              type: "dropdown",
              name: "type",
              title: trans("type"),
              width: 80,
              source: [
                {
                  id: peque.STAKEHOLDER_TYPE_PERSON,
                  name: trans("person"),
                },
                {
                  id: peque.STAKEHOLDER_TYPE_ENTITY,
                  name: trans("entity"),
                },
              ],
            },
            {
              type: "text",
              name: "group",
              title: trans("group"),
              width: 150,
              newOptions: true,
            },
            { type: "text", name: "email", title: trans("email"), width: 150 },
            {
              type: "checkbox",
              name: "invite",
              title: trans("invite"),
              width: 60,
            },
            { type: "text", name: "phone", title: trans("phone"), width: 80 },
            {
              type: "text",
              name: "identifier",
              title: trans("identifier"),
              width: 90,
            },
            {
              type: "text",
              name: "custom_identifier",
              title: trans("custom_identifier"),
              width: 70,
            },
            {
              type: "calendar",
              name: "birth_date",
              title: trans("birthdate"),
              width: 80,
            },
            {
              type: "dropdown",
              name: "civil_status",
              title: trans("civil_status"),
              width: 20,
              source: [
                {
                  id: "single",
                  name: trans("civil_status_single"),
                },
                {
                  id: "married",
                  name: trans("civil_status_married"),
                },
                {
                  id: "married_separate_property",
                  name: trans("civil_status_married_separate_property"),
                },
              ],
            },
            {
              type: "dropdown",
              name: "nationality",
              title: trans("nationality"),
              width: 120,
              source: this.countries,
              autocomplete: true,
            },
            {
              type: "text",
              name: "street",
              title: trans("street"),
              width: 100,
            },
            {
              type: "text",
              name: "postal_code",
              title: trans("postal_code"),
              width: 100,
            },
            { type: "text", name: "city", title: trans("city"), width: 100 },
            {
              type: "dropdown",
              name: "country",
              title: trans("country"),
              width: 120,
              source: this.countries,
              autocomplete: true,
            },
          ],
          onload: (instance) => {
            instance.querySelector("table").classList.add("w-100");

            // place the button inside the spreadsheet
            const $selectAll = instance.querySelector(".jexcel_selectall");
            const $button = document.getElementById("add-stakeholder");
            $button.classList.remove("d-none");
            $selectAll.appendChild($button);
            $selectAll.classList.add("text-center");
            this.findDuplicates(instance)
          },
          onbeforepaste: (worksheet, data, x) => {
            if (Number(x) !== 0) {
              return data;
            }
            // when pasting from row numbers, remove any stakeholder id if all columns are copied
            const rows = data?.split("\n").map((row) => row.split("\t"));
            return rows
              .reduce((current, row) => {
                if (
                  row.length % this.spreadsheet.options.columns.length ===
                  0
                ) {
                  row[0] = "";
                  return [...current, row.join("\t")];
                }
                return current;
              }, [])
              .join("\n");
          },
          oninsertrow: (instance, i, invalidY, list) => {
            const x = {
              type: this.getColumnIndex("type"),
              nationality: this.getColumnIndex("nationality"),
              country: this.getColumnIndex("country"),
            };
            const tds = list[0];
            const y = tds[0].dataset.y;

            if (this.spreadsheet.getValueFromCoords(x.type, y).length < 1) {
              this.spreadsheet.setValueFromCoords(
                x.type,
                y,
                peque.STAKEHOLDER_TYPE_PERSON
              );
            }

            if (
              this.spreadsheet.getValueFromCoords(x.nationality, y).length < 1
            ) {
              this.spreadsheet.setValueFromCoords(
                x.nationality,
                y,
                window.currentCompany.country
              );
            }
            if (this.spreadsheet.getValueFromCoords(x.country, y).length < 1) {
              this.spreadsheet.setValueFromCoords(
                x.country,
                y,
                window.currentCompany.country
              );
            }
            if (typeof this.afterInsertingRow !== "undefined") {
              this.afterInsertingRow();
            }
            this.findDuplicates(instance);
          },
          onafterchanges: (instance, cells) => {
            if (!this.listenToChanges) {
              return;
            }

            cells.forEach((cell) => {
              cell.y = parseInt(cell.y);

              if (this.changedRows.includes(cell.y)) {
                return;
              }

              this.changedRows.push(cell.y);
            });
			this.findDuplicates(instance);
          },
          oncreateeditor: (instance, cell, x, y) => {
            const column = instance.jexcel.options.columns[x];

            if (column.newOptions === undefined) {
              return;
            }

            // move the dropdown
            this.setupSpreadsheetAutocomplete(instance, cell, x, y);

            cell.addEventListener("input", () => {
              const val = cell.querySelector("input").value.trim();
              if (val.length < 1) {
                return;
              }

              this.$dropdownAutocomplete.$input.value = val;
              this.$dropdownAutocomplete.$input.dispatchEvent(
                new Event("input")
              );
              this.dropdownDetails.value = val;
            });
          },
          contextMenu: (el, x, y, e) => {
            let items = [];
            const obj = this.spreadsheet;

            if (y != null) {
              // Insert new row
              if (obj.options.allowInsertRow === true) {
                items.push({
                  title: obj.options.text.insertANewRowBefore,
                  onclick: function () {
                    obj.insertRow(1, parseInt(y), 1);
                  },
                });

                items.push({
                  title: obj.options.text.insertANewRowAfter,
                  onclick: function () {
                    obj.insertRow(1, parseInt(y));
                  },
                });
              }

              if (obj.options.allowDeleteRow === true) {
                items.push({
                  title: obj.options.text.deleteSelectedRows,
                  onclick: function () {
                    obj.deleteRow(
                      obj.getSelectedRows().length ? undefined : parseInt(y)
                    );
                  },
                });
              }
            }

            // Line
            items.push({ type: "line" });

            // Copy
            items.push({
              title: obj.options.text.copy,
              shortcut: "Ctrl + C",
              onclick: function () {
                obj.copy(true);
              },
            });

            // Paste
            if (navigator && navigator.clipboard) {
              items.push({
                title: obj.options.text.paste,
                shortcut: "Ctrl + V",
                onclick: function () {
                  if (obj.selectedCell) {
                    navigator.clipboard.readText().then(function (text) {
                      if (text) {
                        jexcel.current.paste(
                          obj.selectedCell[0],
                          obj.selectedCell[1],
                          text
                        );
                      }
                    });
                  }
                },
              });
            }

            return items;
          },
        }
      );
    });
  }

  setupSpreadsheetAutocomplete(instance, cell, x, y) {
    const $select = document.createElement("select");

    // has selected something from the autocomplete
    $select.addEventListener("change", () => {
      // must be set twice because on first try UI shows the correct name,
      // but jexcel doesn't store it on it's matrix.
      instance.jexcel.updateCell(x, y, $select.value);
      instance.jexcel.updateCell(x, y, $select.value);
    });

    $select.classList.add("d-none");
    this.$form.appendChild($select);

    this.groups.forEach((group) => {
      const $option = document.createElement("option");
      $option.innerText = group;
      $select.appendChild($option);
    });

    this.$dropdownAutocomplete = new AutocompleteSelect($select, {
      inputClasses: ["form-control"],
      dropdownClasses: ["border"],
      eventToListen: "mousedown",
    });
    this.$dropdownAutocomplete.$input.classList.add("d-none");

    this.dropdownDetails = {
      x: null,
      y: null,
      value: null,
    };

    cell.appendChild(this.$dropdownAutocomplete.$container.parentElement);
    this.$dropdownAutocomplete.$select.dispatchEvent(new Event("mousedown"));

    // apply current row value into autocomplete input
    const currentVal = instance.jexcel.getValue(cell);

    if (currentVal.length > 0) {
      this.$dropdownAutocomplete.$input.value = currentVal;
      this.$dropdownAutocomplete.$input.dispatchEvent(new Event("input"));
    }
  }

  getColumnIndex(name) {
    const columns = this.spreadsheet.options.columns;
    for (let i = 0; i < columns.length; i++) {
      const column = columns[i];
      if (
        (typeof column.name !== "undefined" && column.name === name) ||
        column.name === name.replace("-", "_")
      ) {
        return i;
      }
    }
    throw "Column not found";
  }

  showLoader(enable) {
    if (enable) {
      this.$loader.classList.remove("d-none");
    } else {
      this.$loader.classList.add("d-none");
    }
  }

  download() {
    let data = [];

    data.push(this.spreadsheet.getHeaders().split(","));

    this.spreadsheet.getData().forEach((entry) => {
      if (entry[0].length === 0) {
        return;
      }

      entry[3] =
        entry[3] === peque.STAKEHOLDER_TYPE_PERSON
          ? trans("person")
          : trans("entity");
      entry[11] = this.countries.find((c) => c.id === entry[11])?.alpha2;
      entry[15] = this.countries.find((c) => c.id === entry[15])?.alpha2;
      data.push(entry);
    });

    let downloadSpreadsheet = jspreadsheet(
      document.getElementById("download-container"),
      {
        about: false,
        tableOverflow: true,
        tableHeight: "auto",
        tableWidth: "100vw",
        data: data,
        csvFileName: "stakeholders",
        columns: [
          { type: "text", name: "name", title: trans("name"), width: 120 },
          {
            type: "text",
            name: "surnames",
            title: trans("last_name"),
            width: 100,
          },
          { type: "text", name: "type", title: trans("type"), width: 80 },
          { type: "text", name: "group", title: trans("group"), width: 150 },
          { type: "text", name: "email", title: trans("email"), width: 150 },
          {
            type: "checkbox",
            name: "invite",
            title: trans("invite"),
            width: 60,
          },
          { type: "text", name: "phone", title: trans("phone"), width: 80 },
          {
            type: "text",
            name: "identifier",
            title: trans("identifier"),
            width: 90,
          },
          {
            type: "text",
            name: "custom_identifier",
            title: trans("custom_identifier"),
            width: 70,
          },
          {
            type: "text",
            name: "birth_date",
            title: trans("birthdate"),
            width: 80,
          },
          {
            type: "text",
            name: "civil_status",
            title: trans("civil_status"),
            width: 80,
          },
          {
            type: "text",
            name: "nationality",
            title: trans("nationality"),
            width: 120,
          },
          { type: "text", name: "street", title: trans("street"), width: 100 },
          {
            type: "text",
            name: "postal_code",
            title: trans("postal_code"),
            width: 100,
          },
          { type: "text", name: "city", title: trans("city"), width: 100 },
          {
            type: "text",
            name: "country",
            title: trans("country"),
            width: 120,
          },
        ],
      }
    );

    downloadSpreadsheet.download();
  }

  validateAndSendForm() {
    this.showLoader(true);
    this.enableSubmitButton(false);
    this.resetFailedValidations();

    const funcs = [];

    this.getData().forEach((stakeholder) => {
      stakeholder.company = this.companyId;

      funcs.push(() => {
        return new Promise((resolve, reject) => {
          peque
            .api(
              "stakeholders" + (stakeholder.id ? "/" + stakeholder.id : ""),
              stakeholder,
              "post"
            )
            .then((response) => {
              if (stakeholder.id.length < 1) {
                this.spreadsheet.setValueFromCoords(
                  0,
                  stakeholder.rowI,
                  response.result.id
                );
              }
              resolve();
            })
            .catch((error) => {
              reject(error);

              if (error.error === peque.ERROR_UPGRADE_PLAN) {
                peque.showLimitReachedModal("stakeholder-limit");
                return;
              }

              if (typeof error.field === "undefined") {
                return;
              }
              const column = this.getColumnIndex(error.field);
              this.showErrorOnField(
                error.result,
                this.spreadsheet.el.querySelector(
                  '[data-x="' + column + '"][data-y="' + stakeholder.rowI + '"]'
                )
              );
            });
        });
      });
    });
    funcs.push(() => {
      this.showLoader(false);
      location.reload();
    });

    funcs.reduce((prev, cur) => {
      return prev.then(cur).catch((error) => {
        console.error(error);
        this.showLoader(false);
        this.enableSubmitButton(true);
        throw "stop";
      });
    }, Promise.resolve());
  }
}

window.StakeholderMultiEditModal = StakeholderMultiEditModal;
